import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';

import SupervisorLogin from './pages/supervisor/SupervisorLogin';
import SupervisorDashboard from './pages/supervisor/SupervisorDashboard';
import Inspection from './pages/supervisor/Inspection';
import SupervisorPendingAttendance from './pages/supervisor/SupervisorPendingAttendance';

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminReports from './pages/admin/AdminReports';
import DataManagement from './pages/admin/DataManagement';
import AttendanceCalendar from './pages/admin/AttendanceCalendar';
import BulkUpload from './pages/admin/BulkUpload';
import SupervisorMonitoring from './pages/admin/SupervisorMonitoring';
import StorageDashboard from './pages/admin/StorageDashboard';
import AdminSettings from './pages/admin/AdminSettings';
import MonthlyReports from './pages/admin/MonthlyReports';
import PendingAttendance from './pages/admin/PendingAttendance';
import SurveyQuestions from './pages/admin/SurveyQuestions';
import OvertimeManagement from './pages/admin/OvertimeManagement';
import DynamicQuestionnaire from './pages/admin/DynamicQuestionnaire';
import ZoneStaffManagement from './pages/admin/ZoneStaffManagement';
import ZoneStaffAttendance from './pages/admin/ZoneStaffAttendance';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/supervisor/login" replace />} />
            
            {/* Supervisor Routes */}
            <Route path="/supervisor/login" element={<SupervisorLogin />} />
            <Route path="/supervisor/dashboard" element={<SupervisorDashboard />} />
            <Route path="/supervisor/inspection/:parkId" element={<Inspection />} />
            <Route path="/supervisor/inspection/:parkId/edit/:inspectionId" element={<Inspection />} />
            <Route path="/supervisor/pending-attendance" element={<SupervisorPendingAttendance />} />
            
            {/* Legacy inspector routes - redirect to supervisor */}
            <Route path="/inspector/login" element={<Navigate to="/supervisor/login" replace />} />
            <Route path="/inspector/dashboard" element={<Navigate to="/supervisor/dashboard" replace />} />
            <Route path="/inspector/inspection/:parkId" element={<Navigate to="/supervisor/inspection/:parkId" replace />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/reports" element={<AdminReports />} />
            <Route path="/admin/data-management" element={<DataManagement />} />
            <Route path="/admin/calendar" element={<AttendanceCalendar />} />
            <Route path="/admin/bulk-upload" element={<BulkUpload />} />
            <Route path="/admin/supervisor-monitoring" element={<SupervisorMonitoring />} />
            <Route path="/admin/storage" element={<StorageDashboard />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/monthly-reports" element={<MonthlyReports />} />
            <Route path="/admin/pending-attendance" element={<PendingAttendance />} />
            <Route path="/admin/survey-questions" element={<SurveyQuestions />} />
            <Route path="/admin/overtime" element={<OvertimeManagement />} />
            <Route path="/admin/questionnaires" element={<DynamicQuestionnaire />} />
            <Route path="/admin/zone-staff" element={<ZoneStaffManagement />} />
            <Route path="/admin/zone-staff-attendance" element={<ZoneStaffAttendance />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
